import { Award, BadgeCheck } from "lucide-react";

export function VerifiedBadge({ name, className = "", testId }) {
  return (
    <span
      data-testid={testId}
      className={`relative group inline-flex items-center gap-1 cursor-default ${className}`}
    >
      <Award className="w-3 h-3" /> {name}
      <span
        role="tooltip"
        className="pointer-events-none absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 whitespace-nowrap rounded-md bg-slate-900 px-2 py-1 text-[10px] font-semibold text-white opacity-0 shadow-lg transition-opacity duration-150 group-hover:opacity-100 z-30"
      >
        <BadgeCheck className="mr-0.5 inline h-3 w-3 text-green-400" />
        Verified by Care-4U
        <span className="absolute left-1/2 top-full -translate-x-1/2 border-4 border-transparent border-t-slate-900" />
      </span>
    </span>
  );
}
